// extracted by mini-css-extract-plugin
module.exports = {"heroBanner":"HomeBanner_heroBanner__A_Dp6","mobile":"HomeBanner_mobile__z5xUH","desktop":"HomeBanner_desktop__BJYYK"};